import {
  gameState,
  hiveState,
  inventoryState,
  playerState,
} from "../state/stateManager";
import beeIcon from "./../../res/bee.png";
import boxIcon from "./../../res/box.png";
import sugarIcon from "./../../res/sugar.png";
import jarIcon from "./../../res/jar.png";
import honeyFrameIcon from "./../../res/honeyFrame.png";
import { Resources } from "../Resources";
import { sendAlert } from "../utils";
export default class InventoryHUD {
  constructor(activeScene) {
    this.activeScene = activeScene;
    this.inventoryContainer = document.getElementById("inventoryHUD");
    this.inventoryContainer.style.display = "flex";
    this.fastForward = document.getElementById("fastForward");
    this.fastForward.style.display = "none";
    this.display();
  }

  display() {
    Resources.Inventory.play();
    this.inventory = inventoryState.getInventory();
    if (this.activeScene == "home") {
      this.fastForward.style.display = "block";
      this.fastForward.innerHTML = `Fast Forward 7 Days`;
      this.fastForward.onclick = () => {
        console.log("fast forward");
        let speed = gameState.getGameSpeed();
        let originalStart = gameState.getGameStart();
        const week = 604800000 / speed;
        console.log(
          "should fast forward by subtracting ",
          week,
          " from ",
          originalStart
        );
        let hives = hiveState.getHives();
        let newHives = [];
        hives.forEach((hive, i) => {
          hive.lastMutated = hive.lastMutated - week;
          newHives.push(hive);
        });
        //set back the lastSold and lastPerused
        let content = playerState.getContent();
        content.farmersMarket.lastSold = content.farmersMarket.lastSold - week;
        content.mccartys.lastSold = content.mccartys.lastSold - week;
        content.bigBens.lastSold = content.bigBens.lastSold - week;
        content.furdland.lastSold = content.furdland.lastSold - week;
        content.sparkys.lastSold = content.sparkys.lastSold - week;
        content.beeClubMarket.lastPerused =
          content.beeClubMarket.lastPerused - week;
        hiveState.setHives(newHives);
        let newStart = originalStart - week;
        gameState.changeGameStart(newStart);
        sendAlert("Skipped Ahead 7 Days!");
        Resources.Liquid.play();
      };
    }

    this.hives = hiveState.getHives();
    let totalBees =
      this.hives.length +
      this.inventory.nucs.length +
      this.inventory.packages.length +
      this.inventory.splits.length;
    this.inventoryContainer.innerHTML = `<h1>INVENTORY</h1>
    <hr/>
    
    <div class="inventoryRows">
    <div class="inventoryRow"><img src="${jarIcon}"/> <p>${
      this.inventory.filledJars
    }</p></div>
    <div class="inventoryRow"><img src="${beeIcon}"/> <p>${totalBees}</p></div>
        <div class="inventoryRow"><img src="${boxIcon}"/> <p>${
      this.inventory.boxes
    }</p></div>
        <div class="inventoryRow"><img src="${sugarIcon}"/> <p>${
      this.inventory.sugar
    }</p></div><div class="inventoryRow"><img class="honeyFrame"src="${honeyFrameIcon}"/> <p>${parseFloat(
      this.inventory.harvestedHoney
    ).toFixed(2)}</p></div></div>
        ${
          this.activeScene == "home"
            ? `<div id="tutorial">
            
            <p>Purchase Bees Online or in town</p>
              <p>Hit SPACE to add hives</p>
              <p>Hit S to use smoker (useful for calming angry bees!)</p>
            </div>`
            : ""
        }
      `;
  }

  changeHtml(markup) {
    this.inventoryContainer.innerHTML = markup;
  }
  destroy() {
    this.inventoryContainer.style.display = "none";
    this.fastForward.style.display = "none";
  }
}
